"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _EditorHeader = _interopRequireDefault(require("../../Editor/EditorHeader"));

var _ImageAnnotations = _interopRequireDefault(require("../../Media/ImageAnnotations"));

var _PrimusImageMarker = _interopRequireDefault(require("./PrimusImageMarker"));

var _LayoutList = _interopRequireDefault(require("../../Layout/LayoutList"));

var _LayoutModule = _interopRequireDefault(require("../../Module/LayoutModule"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "fixed",
    zIndex: 2000,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  header: {
    position: "relative",
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "flex-start"
  },
  figure: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: theme.spacing(36),
    margin: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      minHeight: theme.spacing(54)
    },
    [theme.breakpoints.up('md')]: {
      minHeight: theme.spacing(72)
    }
  },
  image: {
    position: "relative",
    display: "block",
    maxWidth: "90%",
    maxHeight: "90%"
  },
  action: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(32),
      width: theme.spacing(32),
      height: theme.spacing(32)
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 1,
    "&:hover": {
      opacity: 1
    }
  },
  remove: {
    position: "absolute",
    top: 0,
    right: 0
  },
  removeIcon: {
    fontSize: "18px"
  },
  edit: {
    backgroundColor: "rgba(255,255,255,.5)",
    "&:hover": {
      backgroundColor: "white"
    }
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: theme.spacing(.5),
    overflow: "hidden",
    "& > * + *": {
      marginLeft: theme.spacing(1)
    }
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: "bold"
  },
  annotations: {
    padding: theme.spacing(2),
    overflowY: "scroll"
  }
}));

const AnnotationsItem = (_ref) => {
  let index = _ref.index,
      idPrefix = _ref.idPrefix,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["index", "idPrefix", "onChange"]);

  const color = props.color,
        shape = props.shape;
  const id = idPrefix + "_" + index;

  const toggleShape = () => {
    if (shape === "circle") {
      onChange(_extends({}, props, {
        shape: "rectangle"
      }));
    } else {
      onChange(_extends({}, props, {
        shape: "circle"
      }));
    }
  };

  return _react.default.createElement(_LayoutModule.default, {
    expanded: true
  }, _react.default.createElement("div", {
    onClick: toggleShape
  }, shape), color || "red", " ", shape || "circle");
};

const AnnotationsList = ({
  formData = [],
  idPrefix,
  onChangeIndex
}) => {
  const title = formData.length + " markeringer";
  return _react.default.createElement(_LayoutList.default, {
    title: title
  }, JSON.stringify(formData));
};

const PrimusImageAnnotate = ({
  id,
  title,
  imageUrl,
  imageAnnotations = [],
  formData = {},
  onChange,
  onExpand
}) => {
  const classes = useStyles();

  const _useState = (0, _react.useState)(imageAnnotations || []),
        annotations = _useState[0],
        setAnnotations = _useState[1];

  const handleChange = annotations => {
    //        onChange && onChange({...formData, imageAnnotations: annotations})
    setAnnotations(annotations);
  };

  const handleIndexChange = (index, value) => {
    const newAnnotations = annotations.map((item, i) => {
      // We need to treat undefined items as nulls to have validation.
      // See https://github.com/tdegrunt/jsonschema/issues/206
      const jsonValue = typeof value === "undefined" ? null : value;
      return index === i ? jsonValue : item;
    });
    onChange && onChange(_extends({}, formData, {
      imageAnnotations: newAnnotations
    })); //        setAnnotations(newAnnotations)
  };

  const handleBack = () => {
    onExpand && onExpand({
      "id": "root_attachments"
    });
  };

  return _react.default.createElement(_Paper.default, {
    square: true,
    className: classes.root
  }, _react.default.createElement(_Paper.default, {
    square: true,
    className: classes.header
  }, _react.default.createElement(_EditorHeader.default, {
    title: "Vedlegg:",
    subtitle: title,
    onBack: handleBack,
    primaryAction: {
      icon: "check",
      variant: "outlined",
      label: "Lagre og lukk"
    }
  }), _react.default.createElement("figure", {
    className: classes.figure
  }, _react.default.createElement(_ImageAnnotations.default, {
    overflow: "visible",
    imageUrl: imageUrl,
    imageAnnotations: annotations,
    markerTemplate: _PrimusImageMarker.default,
    onChange: handleChange
  }))), _react.default.createElement("section", {
    className: classes.annotations
  }, _react.default.createElement(AnnotationsList, {
    formData: annotations,
    idPrefix: id,
    onChangeIndex: handleIndexChange
  })));
};

var _default = PrimusImageAnnotate;
exports.default = _default;
module.exports = exports.default;